import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ActionKeySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ActionKeySVG;
